/**
 * Testi italiani del blocco «Pubblicazione sugli store» della scheda «Strumenti» di un
 * progetto (ADR 0045).
 */

/** Testi della pubblicazione mobile. */
export const mobileRelease = {
  title: 'Pubblicazione sugli store',
  intro:
    'Gli agenti preparano l’app e propongono una pubblicazione. Firma e caricamento li fa GitHub Actions fuori dal set, solo dopo la tua approvazione: le credenziali non arrivano mai agli agenti.',
  loadFailed: 'Caricamento della pubblicazione non riuscito. Riprova.',
  dispatchWarning:
    'L’ultimo avvio automatico del workflow non è riuscito per i permessi del collegamento GitHub. Avvia il workflow «institor-mobile-release» a mano dalla pagina Actions del repository, sul tag creato.',
  cancel: 'Annulla',
  platforms: {
    android: 'Google Play',
    ios: 'App Store',
  },
  kinds: {
    android_upload_key: 'Chiave di caricamento Android',
    android_play_service_account: 'Service account di Google Play',
    ios_asc_api_key: 'Chiave API di App Store Connect',
    ios_signing: 'Certificato e profilo iOS',
  },
  help: {
    android_upload_key:
      'Il file della chiave (.jks o .keystore) con cui firmi gli aggiornamenti, con le sue password e il nome della chiave.',
    android_play_service_account:
      'Il file JSON di un service account Google con accesso alla tua Play Console (Utenti e autorizzazioni, permesso di rilascio).',
    ios_asc_api_key:
      'Una chiave API di App Store Connect con ruolo App Manager: il file .p8, il suo Key ID e l’Issuer ID.',
    ios_signing:
      'Il certificato di distribuzione Apple (.p12) con la sua password e il profilo di provisioning App Store (.mobileprovision) dell’app.',
  },
  fields: {
    keystore_base64: 'File della chiave',
    store_password: 'Password del keystore',
    key_alias: 'Nome della chiave (alias)',
    key_password: 'Password della chiave',
    service_account: 'File JSON del service account',
    private_key: 'File .p8',
    key_id: 'Key ID',
    issuer_id: 'Issuer ID',
    certificate_p12_base64: 'Certificato .p12',
    certificate_password: 'Password del certificato',
    provisioning_profile_base64: 'Profilo di provisioning',
  },
  settings: {
    title: 'Identificativi delle app',
    android_package: 'Pacchetto Android',
    android_packageHelp: 'Per esempio it.tuaazienda.app. Deve essere uguale a quello dell’app nella Play Console.',
    ios_bundle_id: 'Bundle id iOS',
    ios_bundle_idHelp: 'Per esempio it.tuaazienda.app. Deve essere uguale a quello in App Store Connect.',
    ios_team_id: 'Team id Apple',
    ios_team_idHelp: 'Dieci caratteri, nella pagina Membership del tuo account sviluppatore.',
    save: 'Salva identificativi',
    saved: 'Identificativi salvati.',
    saveFailed: 'Salvataggio non riuscito. Riprova.',
  },
  credentials: {
    title: 'Credenziali',
    notice:
      'Il valore va direttamente al custode dei segreti di institor. Dopo il salvataggio nessuno lo può rileggere, nemmeno da qui.',
    name: 'Credenziale',
    state: 'Stato',
    actions: 'Comandi',
    present: 'Caricata',
    missing: 'Mancante',
    upload: 'Carica',
    replace: 'Sostituisci',
    uploadAccessible: 'Carica {{name}}',
    save: 'Salva',
    saved: 'Credenziale salvata.',
    saveFailed: 'Salvataggio non riuscito: controlla file e campi, poi riprova.',
    fileRead: 'File letto.',
    fileInvalid: 'File non leggibile. Scegli il file giusto.',
    remove: 'Elimina',
    removeAccessible: 'Elimina {{name}}',
    removeTitle: 'Eliminare la credenziale?',
    removeText: '«{{name}}» viene cancellata. Le pubblicazioni non partono finché non la carichi di nuovo.',
    removed: 'Credenziale eliminata.',
  },
  releases: {
    title: 'Pubblicazioni',
    empty: 'Nessuna pubblicazione proposta.',
    version: 'Versione',
    store: 'Store',
    commit: 'Commit',
    state: 'Stato',
    proposed: 'Proposta',
    actions: 'Comandi',
    run: 'Esecuzione su GitHub',
    approve: 'Approva',
    reject: 'Rifiuta',
    approveAccessible: 'Approva la versione {{version}}',
    rejectAccessible: 'Rifiuta la versione {{version}}',
    approveTitle: 'Approvare la pubblicazione?',
    approveText:
      'La versione {{version}} del commit {{commit}} va sul canale {{track}}. GitHub Actions firma e carica l’app con le credenziali del progetto. L’approvazione vale 24 ore.',
    rejectTitle: 'Rifiutare la pubblicazione?',
    rejectText: 'La versione {{version}} non viene pubblicata.',
    approved: 'Pubblicazione approvata.',
    rejected: 'Pubblicazione rifiutata.',
    decideFailed: 'Operazione non riuscita. Riprova.',
  },
  publisher: {
    title: 'Workflow di pubblicazione mobile',
    intro:
      'Repository con i workflow che firmano e caricano le app sugli store. Lo scrive solo institor, gli agenti non lo raggiungono. Aggiornalo dopo ogni rilascio di institor che cambia i workflow.',
    sync: 'Aggiorna workflow',
    synced: 'Workflow aggiornati.',
    done_one: 'Repository {{repository}} aggiornato: {{count}} file scritto.',
    done_other: 'Repository {{repository}} aggiornato: {{count}} file scritti.',
    missing: 'Mancano nel pacchetto di institor: {{files}}.',
    failed: 'Aggiornamento non riuscito. Controlla il collegamento GitHub di institor, poi riprova.',
  },
  states: {
    proposed: 'Da approvare',
    approved: 'Approvata',
    rejected: 'Rifiutata',
    credentials_issued: 'In caricamento',
    expired: 'Scaduta',
    succeeded: 'Pubblicata',
    failed: 'Non riuscita',
  },
};

/** Forma dei testi della pubblicazione mobile. */
export type MobileReleaseTexts = typeof mobileRelease;
